export default {"src":"/_next/static/media/nurse-with-large-green-chat-box.9d97654c.svg","height":373,"width":260};